import { Check } from "lucide-react";
const serviceAreas = ["Baumpflege Fridtjof Straesser", "Inhaber: Fridtjof Sträßer", "Bornkmapsweg 38a 22926 Ahrensburg", "Email: f.sora@pm.me"];
export default function WhereWeServe() {
  return <section data-section-id="228325" id="company-information" className="bg-background text-foreground">
      {}
      <div className="bg-accent text-accent-foreground py-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-center mb-12 text-primary">
            Impressum & Unternehmensdaten
          </h2>
          
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-6">
            {serviceAreas.map((area, i) => <div key={i} data-index={i} className="flex items-center gap-2">
                <Check className="w-5 h-5 text-primary shrink-0" strokeWidth={3} />
                <span className="text-lg font-semibold font-default text-foreground">
                  {area}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}